import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import SecurityIcon from "@mui/icons-material/Security";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";

function Roles() {
  const [tableData, settableData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    baseUrl
      .get("/role/findRole", { headers: { status: true } })
      .then((response) => settableData(response.data.data))
      .catch((error) => console.log(error));
  }, []);

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
            <SecurityIcon className="text-primary" sx={{ fontSize: 16 }} />
          </div>
          <div>
            <h2 className="text-sm font-bold text-slate-800 dark:text-slate-100">Active Roles</h2>
            <p className="text-xs text-slate-500 dark:text-slate-400">{tableData.length} roles found</p>
          </div>
        </div>
      </div>
      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {tableData.map((item: any, i: number) => (
          <div key={i} className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 p-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-[10px] font-medium text-slate-400 dark:text-slate-500">#{i + 1}</span>
              {item?.admin && (
                <span className="px-1.5 py-0.5 bg-indigo-100 text-indigo-600 text-[10px] font-medium rounded-md">Admin</span>
              )}
            </div>
            <h3 className="font-semibold text-xs text-slate-800 dark:text-slate-100 mb-2">{item?.roleName}</h3>
            {!item?.admin && (
              <div className="flex gap-1.5">
                <button
                  onClick={() => navigate(`/client/staff/role/edit-role/${item?._id}`)}
                  className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg text-xs font-medium hover:shadow-lg hover:shadow-primary/20 transition-all"
                >
                  <EditIcon sx={{ fontSize: 14 }} /> Edit
                </button>
                <button className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-red-50 dark:bg-red-900/40 text-red-600 dark:text-red-400 rounded-lg text-xs font-medium hover:bg-red-100 dark:hover:bg-red-900/60 transition-colors">
                  <BlockIcon sx={{ fontSize: 14 }} /> Deactivate
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        <table className="w-full">
          <thead className="border-b border-slate-200 dark:border-slate-600">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">No</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Role Name</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
            {tableData.map((item: any, i: number) => (
              <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
                <td className="px-3 py-2 text-xs text-slate-500 dark:text-slate-400">{i + 1}</td>
                <td className="px-3 py-2">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-xs text-slate-800 dark:text-slate-100">{item?.roleName}</span>
                    {item?.admin && (
                      <span className="px-1.5 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-[10px] font-medium rounded-md">Admin</span>
                    )}
                  </div>
                </td>
                <td className="px-3 py-2">
                  {!item?.admin && (
                    <div className="flex gap-1.5">
                      <button
                        onClick={() => navigate(`/client/staff/role/edit-role/${item?._id}`)}
                        className="flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg text-xs font-medium hover:shadow-lg hover:shadow-primary/20 transition-all"
                      >
                        <EditIcon sx={{ fontSize: 14 }} /> Edit
                      </button>
                      <button className="flex items-center gap-1 px-3 py-1.5 bg-red-50 dark:bg-red-900/40 text-red-600 dark:text-red-400 rounded-lg text-xs font-medium hover:bg-red-100 dark:hover:bg-red-900/60 transition-colors">
                        <BlockIcon sx={{ fontSize: 14 }} /> Deactivate
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Roles;
